import { Box } from '@givebutter/primitives/box';
import { useMediaQuery } from '@givebutter/react-util';
import * as NavMenuPrimitive from '@radix-ui/react-navigation-menu';
import { NavLink, NavLinkProps } from 'components/nav-link';
import { twMerge } from 'tailwind-merge';

interface NavMenuProps
    extends Pick<NavMenuPrimitive.NavigationMenuProps, 'orientation' | 'children' | 'className'> {
    'aria-label'?: string;
}
const NavMenu = ({ children, className, orientation = 'horizontal', ...rest }: NavMenuProps) => {
    const ariaLabel = rest['aria-label'] ?? 'Menu';
    const isDesktop = useNavMenuBreakpoint();
    return (
        <NavMenuPrimitive.Root
            orientation={orientation}
            aria-label={ariaLabel}
            className={className}
        >
            <Box className="overflow-auto p-1">
                <NavMenuPrimitive.List
                    className={twMerge(
                        'item-start flex w-full',
                        orientation === 'vertical' && isDesktop && 'flex-col',
                    )}
                >
                    {children}
                </NavMenuPrimitive.List>
            </Box>
        </NavMenuPrimitive.Root>
    );
};

interface NavMenuItemProps extends Omit<NavLinkProps, 'className'> {
    className?: string;
}
const NavMenuItem = ({ className, children, ...rest }: NavMenuItemProps) => {
    const isDesktop = useNavMenuBreakpoint();
    return (
        <NavMenuPrimitive.Item>
            <NavMenuPrimitive.Link asChild>
                <NavLink
                    className={twMerge(
                        'block',
                        !isDesktop && 'flex-nowrap whitespace-nowrap',
                        className,
                    )}
                    {...rest}
                >
                    {children}
                </NavLink>
            </NavMenuPrimitive.Link>
        </NavMenuPrimitive.Item>
    );
};

const BREAKPOINT = 1024;
const useNavMenuBreakpoint = () => {
    return useMediaQuery(`(min-width: ${BREAKPOINT}px)`);
};

const Root = NavMenu;
const Item = NavMenuItem;

export {
    Root,
    Item,
    //
    NavMenu,
    NavMenuItem,
};
